
import { defineComponent } from "vue";
import {
    //Sticky,
    Tabbar,
    TabbarItem,
} from "vant";
// import { useRoute } from "vue-router";

export default defineComponent({
    // setup() {
    //     const router = useRoute();
    //     const active = ref(router.meta.tabbarActive);
    //     return { active };
    // },
    components: {
        // [Sticky.name]: Sticky,
        [Tabbar.name]: Tabbar,
        [TabbarItem.name]: TabbarItem,
    },
    name: "TabbarLayout",
    data() {
        return {
            tabbarData: [
                {
                    text: "公益池",
                    icon: " iconfont d-gy-home",
                    route: "/gy/home",
                },
                {
                    text: "个人中心",
                    icon: " iconfont d-gy-me",
                    route: "/gy/my/home",
                },
            ],
        };
    },
});
